import dayjsBase, { ConfigType, Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjsBase.extend(utc);
dayjsBase.extend(timezone);
dayjsBase.extend(customParseFormat);

/** The business timezone used throughout the application, independent of the browser timezone. */
export const APP_TIMEZONE = 'Asia/Ho_Chi_Minh';

/** Create a Day.js value displayed in the Ho Chi Minh City timezone (UTC+7). */
const HAS_EXPLICIT_TIMEZONE = /(Z|[+-]\d{2}:?\d{2})$/i;

const dayjs = (input?: ConfigType): Dayjs => {
  if (input === undefined) return dayjsBase().tz(APP_TIMEZONE);

  // Treat timezone-less strings as Saigon wall-clock values; timestamps, Date objects,
  // and ISO strings with an offset represent absolute instants that are converted to Saigon.
  if (typeof input === 'string' && !HAS_EXPLICIT_TIMEZONE.test(input.trim())) {
    return dayjsBase.tz(input, APP_TIMEZONE);
  }

  return dayjsBase(input).tz(APP_TIMEZONE);
};

/** Strictly validate user-entered calendar values without browser-dependent parsing. */
export const isValidDate = (input: ConfigType, format: string): boolean => dayjsBase(input, format, true).isValid();

export default dayjs;
